<template lang="html">
  <div class="form-control"
    :class="fieldClasses">
    <div class="field-wrapper">
      <label class="form-label">{{label}}</label>
      <Tooltip
          v-if="tooltip"
          :tooltipText="tooltip"/>
      <div class="wrapper">
        <div class="is-block" :class="getRowClass">
          <template v-for="(option, index) in options">
            <div class="radio" :class="getColumnClass">
              <input
              v-model="sync_model"
              type="radio"
              :name="name"
              :id="name + '_' + option.value"
              :value="option.value">
              <label
              :for="name + '_' + option.value">{{option.label}}</label>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'VqRadio',
  props: {
    label: String,
    name: String,
    fieldClasses: String,
    options: Array,
    model: Object,
    tooltip: String,
    default: String,
    columns: {
      type: Number,
      default: 1,
      required: false,
    },
  },
  components: {
    Tooltip,
  },
  mounted() {
    if (!this.model.hasOwnProperty('value')) {
      this.$emit('update:model', { value: '' });
    }
  },
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {
    sync_model: {
      get() {
        return this.model.value;
      },
      set(val) {
        this.$emit('update:model', { value: val });
      },
    },
    getRowClass() {
      return this.columns > 1 ? 'row' : 'group';
    },
    getColumnClass() {
      return `col-tab-${12 / this.columns}`;
    },
  },
  watch: {
    model: {
      immediate: true,
      handler() {
        if (!this.model.hasOwnProperty('value')) {
          this.$emit('update:model', { value: '' });
        } else if (!this.model.label) {
          const option = this.options.filter(el => el.value == this.model.value);
          this.model.label = option[0].label;
          this.model.value = option[0].value;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
</style>
